import classNames from "classnames"
import { useController } from "react-hook-form"

import "./Radio.scss"

interface IRadio {
  /** Nome do radio group */
  name: string
  /** Id da opção, obrigatório para poder triggar pela label */
  id: string
  /** Valor da opção */
  value: string
  /** Controle de campo pelo useForms() do react-hooks-form */
  control: any
  /** Texto de label ao lado do checkmark, opcional */
  label?: string
  /** Boolean de se o campo é desabilitado */
  isDisabled?: boolean
  /** Classes para customização */
  className?: string
  /** Para conteúdo de label customizada */
  children?: any
  /** Para controlar a obrigatoriedade do campo */
  required?: boolean
  /** Para alterar o que é lido pelo leitor de telas */
  ariaLabel?: string
}

const Radio = ({
  name,
  id,
  isDisabled,
  value,
  label,
  className,
  control,
  children,
  required,
  ariaLabel = "",
  ...props
}: IRadio) => {
  const rules = { required }
  const { field } = useController({ name, control, rules })

  const isChecked = field.name === name && field.value === value

  const radioClass = classNames("ds-radio", className)
  const markupClass = classNames("ds-radio__markup", {
    "ds-radio__markup--disabled": isDisabled,
  })
  const labelClass = classNames("ds-radio__label", {
    "ds-radio__label--disabled": isDisabled,
    "ds-radio__label--checked": isChecked,
  })
  const labelContent = children || label || ""

  return (
    <div className={radioClass}>
      <label className={labelClass} htmlFor={id}>
        <div className="ds-radio__field">
          <input
            {...field}
            {...props}
            name={name}
            type="radio"
            id={id}
            value={value}
            disabled={isDisabled}
            className={markupClass}
            checked={isChecked}
            role="radio"
            {...(ariaLabel ? { "aria-label": ariaLabel } : { "aria-label": labelContent })}
          />
          <span className="ds-radio__span" aria-hidden>
            {labelContent}
          </span>
        </div>
      </label>
    </div>
  )
}

export default Radio
